/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Rag_Step_3Inputs */

const en_svc_rag_step_3 = /** @type {(inputs: Svc_Rag_Step_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Test answers against real questions your team and customers ask.`)
};

const lv_svc_rag_step_3 = /** @type {(inputs: Svc_Rag_Step_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pārbaudām atbildes ar reāliem jautājumiem, ko uzdod Jūsu komanda un klienti.`)
};

/**
* | output |
* | --- |
* | "Test answers against real questions your team and customers ask." |
*
* @param {Svc_Rag_Step_3Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_rag_step_3 = /** @type {((inputs?: Svc_Rag_Step_3Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Rag_Step_3Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_rag_step_3(inputs)
	return en_svc_rag_step_3(inputs)
});